import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SecondaryButton } from 'common/components';
import { ReactComponent as CloseIcon } from 'applicaiton/assets/close.svg';
import { ReactComponent as SuccesslIcon } from 'applicaiton/assets/success-icon.svg';
import { StyledModal } from './styles';

interface SuccessModalProps {
  profileName: string;
  onClose: () => void;
}

const SuccessModal: FC<SuccessModalProps> = ({ profileName, onClose }) => {
  const { t } = useTranslation();
  return (
    <StyledModal>
      <CloseIcon onClick={onClose} />
      <div>
        <SuccesslIcon />
        <p>
          {t('clinicsConfiguration.delete_profile.success.titlePart1')}{' '}
          <span>{profileName}</span>{' '}
          {t('clinicsConfiguration.delete_profile.success.titlePart2')}
        </p>
        <SecondaryButton onClick={onClose}>
          {t('clinicsConfiguration.delete_profile.success.ok')}
        </SecondaryButton>
      </div>
    </StyledModal>
  );
};

export default SuccessModal;
